import * as types from "./actions";
import APIUtil from "../config/APIUtil";
import UrlConstants from "../config/UrlConstants";
import * as code from "../config/Constants";

export function getPublicFormAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.getPublicFormByIdUrl,
      data,
      true
    ).then((response) => {
      // console.log('getPublicFormAction response: ', response);
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_PUBLIC_FORM_BY_ID,
          getPublicFormData: response.data,
        });
      } else {
        dispatch({
          type: types.GET_PUBLIC_FORM_BY_ID,
          getPublicFormData: [],
        });
      }

      return response.data;
    });
  };
}

export function addPublicFormAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.addPublicFormUrl, data, true).then(
      (response) => {
        // console.log('addPublicFormAction response: ', response);
        if (response.status === code.OK) {
          dispatch({
            type: types.ADD_PUBLIC_FORM,
            addPublicFormData: response.data,
          });
        } else {
          dispatch({
            type: types.ADD_PUBLIC_FORM,
            addPublicFormData: [],
          });
        }

        return response.data;
      }
    );
  };
}

export function updatePublicFormAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.updatePublicFormUrl,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.UPDATE_PUBLIC_FORM,
          updatedPublicFormData: response.data,
        });
      } else {
        dispatch({
          type: types.UPDATE_PUBLIC_FORM,
          updatedPublicFormData: [],
        });
      }

      return response.data;
    });
  };
}

export function deletePublicFormAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.deletePublicFormUrl,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.DELETE_PUBLIC_FORM,
          isPublicFormDeleted: true,
        });
      } else {
        dispatch({
          type: types.DELETE_PUBLIC_FORM,
          isPublicFormDeleted: false,
        });
      }
    });
  };
}

export function isPublicFormValidAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.isPublicFormValidUrl,
      data,
      true
    ).then((response) => {
      // console.log('isPublicFormValidAction response: ', response);
      if (response.status === code.OK) {
        dispatch({
          type: types.IS_PUBLIC_FORM_VALID,
          isPublicFormValid: true,
        });
      } else {
        dispatch({
          type: types.IS_PUBLIC_FORM_VALID,
          isPublicFormValid: false,
        });
      }
    });
  };
}



export function generateQRcodeAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.generateQRcodeUrl, data, true).then(
      (response) => {
        // console.log('addPublicFormAction response: ', response);
        if (response.status === code.OK) {
          dispatch({
            type: types.GET_PUBLIC_FORM_BY_ID,
            addPublicFormData: response.data,
          });
        } else {
          dispatch({
            type: types.GET_PUBLIC_FORM_BY_ID,
            addPublicFormData: [],
          });
        }

        return response.data;
      }
    );
  };
}

